const styles = {
  /**
   * Can be used to define default styles, set by using theme-ui's Styled.root.
   * @see https://theme-ui.com/styled#styledroot */
  root: {
    fontFamily: 'body',
    fontWeight: 'body',
    lineHeight: 'body',
    letterSpacing: 'body',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
  },
};

export default styles;
